import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface SmsFallbackBannerProps {
  variant: 'delivery_failed' | 'daily_cap' | 'max_attempts';
  onSwitchToEmail: () => void;
  className?: string;
}

const TITLE_KEY: Record<SmsFallbackBannerProps['variant'], string> = {
  delivery_failed: 'auth.smsFallback.title',
  daily_cap: 'auth.smsFallback.dailyCapTitle',
  max_attempts: 'auth.smsFallback.maxAttemptsTitle',
};

const MESSAGE_KEY: Record<SmsFallbackBannerProps['variant'], string> = {
  delivery_failed: 'auth.errors.smsDeliveryFailed',
  daily_cap: 'auth.errors.dailyCapExceeded',
  max_attempts: 'auth.errors.maxAttempts',
};

export function SmsFallbackBanner({ variant, onSwitchToEmail, className }: SmsFallbackBannerProps) {
  const { t } = useTranslation();

  const titleKey = TITLE_KEY[variant];
  const messageKey = MESSAGE_KEY[variant];

  return (
    <div
      role='alert'
      className={cn(
        'flex flex-col gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900',
        className,
      )}>
      <p className='font-medium'>{t(titleKey)}</p>
      <p>{t(messageKey)}</p>
      <button
        type='button'
        onClick={onSwitchToEmail}
        className={cn(
          'self-start rounded-md bg-amber-900 px-3 py-1.5 text-xs font-medium text-white',
          'hover:bg-amber-800 focus:outline-none focus:ring-2 focus:ring-amber-700 focus:ring-offset-1',
        )}>
        {t('auth.smsFallback.tryEmail')}
      </button>
    </div>
  );
}
